"use client";

import { BSREdit } from "./bsr/BSREdit";
import { createBSRExperimentIcon } from "./createBSRExperimentIcon";
import { Edit as LegacyEdit } from "./legacy/Edit";

export const Edit = createBSRExperimentIcon(LegacyEdit, BSREdit);
